
/* eslint-disable */

function eventDelegate(parentSelector: string, targetSelector: string, events: string, foo: ()=>void) {
  // 触发执行的函数
  function triFunction(e: Event) {
      // 兼容性处理
      let event = e || window.event;

      // 获取到目标阶段指向的元素
      let target = event.target || event.srcElement;

      // 获取到代理事件的函数
      let currentTarget = event.currentTarget;

      // 处理 matches 的兼容性
      if (!Element.prototype.matches) {

          Element.prototype.matches =
          // @ts-ignore
            Element.prototype.matchesSelector ||
            // @ts-ignore
            Element.prototype.mozMatchesSelector ||
            // @ts-ignore
            Element.prototype.msMatchesSelector ||
            // @ts-ignore
            Element.prototype.oMatchesSelector ||
            Element.prototype.webkitMatchesSelector ||
            function(s) {
              // @ts-ignore
                let matches = (this.document || this.ownerDocument).querySelectorAll(s);
                let i = matches.length;
                // @ts-ignore
                while (--i >= 0 && matches.item(i) !== this) {}
                return i > -1;
            };
      }

      // 遍历外层并且匹配
      while (target && target !== currentTarget) {
          // 判断是否匹配到我们所需要的元素上
          // @ts-ignore
          if (target && target.matches(targetSelector)) {
              let sTarget = target;
              // 执行绑定的函数，注意 this
              // @ts-ignore
              foo.call(sTarget, Array.prototype.slice.call(arguments));
          }
          // @ts-ignore
          target = target && target.parentNode;
      }
  }

  // 如果有多个事件的话需要全部一一绑定事件
  events.split('.').forEach(function (evt) {
      // 多个父层元素的话也需要一一绑定
      Array.prototype.slice.call(document.querySelectorAll(parentSelector)).forEach(function ($p) {
          $p.addEventListener(evt, triFunction);
      });
  });
}


interface IObj {
  [key:string] : string
}


function parseQueryString(url: string) {
  let pos;
  let obj = {};
  if ((pos = url.indexOf('?')) !== -1) {
      let param = url.substring(pos + 1, url.length);
      let paramArr = param.split('&');
      let keyValue = [];
      for (let i = 0, l = paramArr.length; i < l; i++) {
          keyValue = paramArr[i].split('=');
          obj[keyValue[0]] = keyValue[1];
      }
  }
  return obj;
}

function report(obj: IObj, extParam?: string) {
  var obj = obj || {};
  let oUrl: IObj = parseQueryString(location.search);
  let pro = obj.pro;

  if (!window.YA) {
      return false;
  }


  let source: IObj = {
      pro: pro, // 产品给的
      pas: window.YA.cookie.get('username') || '',
      yyuid: window.YA.cookie.get('yyuid') || '',
      pageType: 'root',
      rso: oUrl.rso || '',
      rso_desc: '',
      eid: '',
      eid_desc: ''
  };

  for (let property in obj) {
      source[property] = obj[property];
  }


  window.ya = new window.YA(source.pro, source.pas, {
      pageType: source.pageType,
      yyuid: source.yyuid
  });

  if (extParam) {
    window.ya.setExtParam(extParam);
  }


  window.ya.reportProductStartUp({
      pro: source.pro,
      rso: source.rso,
      rso_desc: source.rso_desc
  });

  window.ya.startProductHeartbeat({
    pro: source.pro,
    rso: source.rso,
    rso_desc: source.rso_desc
  });

  if (source.eid) {
    window.ya.reportProductEvent({
      eid: source.eid
    });
  }

  // 点击上报
  eventDelegate('body', '.clickstat', 'click', function(this: HTMLElement) {

      let eid = this.dataset.eid;
      let label =  this.dataset.label || '';

      if (eid) {
        window.ya.reportProductEvent({
          eid: eid,
          label: label
        });
      }
  });
}


function getScriptCache(url: string, callback: ()=>void) {

  let head = document.getElementsByTagName('head')[0] || document.documentElement;
  let script = document.createElement('script');
  script.type = 'text/javascript';
  script.async = true;
  script.charset = 'utf-8';
  script.src = url;
  // @ts-ignore
  script.onload = script.onreadystatechange = function () {
    // @ts-ignore
      if (!script.readyState || /loaded|complete/.test(script.readyState)) {
          callback && callback();
          // @ts-ignore
          script.onload = script.onreadystatechange = null;
          if (script.parentNode) {
              script.parentNode.removeChild(script);
          }
      }
  };
  head.insertBefore(script, null);
}


// function addHandler(element: HTMLElement | Window, type: string, handler: ()=>void) {
//   return element.addEventListener(type, handler, false);
// }

function resetReport() {
  let _hmt = window.yaReportArr || [];
  if (_hmt.length) {
      for (let i = 0; i < _hmt.length; i++) {
        window.ya && window.ya.reportProductEvent(_hmt[i]);
      }
  }

  window.yaReportArr = [];
  // @ts-ignore
  window.yaReportArr.push = function(obj: any) {
    if (window.ya) {
        if (obj.actionType && window.ya[obj.actionType]) {
            window.ya[obj.actionType](obj.param)
        } else {
            window.ya.reportProductEvent(obj);
        }
    }
  };
}

// window.yaReportArr.push({
//     actionType: 'setExtParam',
//     param: '__yaadid=456&__yarso=FROM_ADS8&ya_websiteid=yy.com&t=xx'
// })


let getYajs = (function() {
  let btn = true;

  return function(obj: IObj, extParam?: string) {
      if (btn) {
          btn = false;
          getScriptCache('https://static-jw.msstatic.com/rp/ya-huya.finall.min.js', function() {
              report(obj, extParam);
              resetReport();
          });
      }
  };
})();


function yaReport(obj: IObj, extParam?: string) {
  // addHandler(window, 'load', function() {
  //     getYajs(obj);
  // });

  // setTimeout(function() {
  //     getYajs(obj);
  // }, 3000);

  getYajs(obj, extParam)
}

export default yaReport;

